



// import Earn from './Earn';
// import Schools from './Schools';
import { Link, useNavigate } from 'react-router-dom';
import DataTable from '../components/DataTable';
import ModalHeader from '../components/ModalHeader';




import { BsAlarm, BsArrowLeftShort } from "react-icons/bs";
import { RiDatabase2Line } from "react-icons/ri";



// import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import DateRangePicker from '@wojtekmaj/react-daterange-picker/dist/DateRangePicker';
import dayjs from 'dayjs';
import 'dayjs/locale/el';
import { useState } from 'react';
import "react-datepicker/dist/react-datepicker.css";

import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TextField } from '@mui/material';
import useAuth from '../hooks/useAuth';




function Database() {

    const { isAuthenticated, logout, user,  } = useAuth();

    const [date, setDate] = useState(dayjs());

      //only if user.role === 'admin' or 'user3' or 'user1' can see the data table
    //else redirect to /select with a message
    


    // const [timestamps, settimestamps] = useState( {
    //     from : 121212,
    //     to: 12121211,
    // })



    // function getTimestampsFromDate(date) {
       
    //     var firstDay = new Date(date.getFullYear(), date.getMonth(), 1).getTime();
    //     var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23).getTime();

       
    //     return {
    //         from : firstDay,
    //         to: lastDay,
    //     }
    // }


    // const [startDate, setStartDate] = useState(dayjs().subtract(1, 'month').toDate());
    // const [endDate, setEndDate] = useState(new Date());

    // const [value, onChange] = useState([dayjs().subtract(1, 'month').subtract(-1,'day').toDate(), new Date()]);
    // const [value, onChange] = useState([dayjs().subtract(1, 'month').subtract(-1,'day').toDate(), new Date()]);

    const [value, onChange] = useState([dayjs().subtract(30, 'day').startOf('day').toDate(), dayjs().endOf('day').toDate()]);
   

    if (!isAuthenticated || !user || !user.role || !['admin', 'user3', 'user1'].includes(user.role)) {
        
        return (
            <div className="flex flex-col items-center justify-center h-screen">
                <h1 className="text-2xl font-bold text-red-500">Δεν έχετε πρόσβαση σε αυτή τη σελίδα</h1>
                <Link to="/select" className="mt-4 text-blue-500 hover:underline">Επιστροφή στην επιλογή λειτουργίας</Link>
            </div>
        );
    }



    return (
        <div className="flex flex-col justify-between bg-white">


            <ModalHeader title="Διαλογή στην Πηγή" subtitle="Database"></ModalHeader>

            <div className='items-center justify-between mx-auto mb-0 -mt-2 lg:flex lg:px-0'>
                {/* <h3 className="flex justify-center w-auto text-xl font-semibold text-app_green_light bg-app_yellow">
            Διαλέξτε Λειτουργία
                </h3> */}
                <Link to={"/select"} className="flex text-app_green_light shadow-md  font-bold rounded-full text-lg px-10 py-2 text-center">
                    <BsArrowLeftShort className='self-center w-6 h-6 text-app_green_light' /> Επιστροφή
                </Link>
                <div  
                onClick={() => {
                    logout()
                }}
                className="cursor-pointer ml-3 flex text-gray-400 shadow-md  font-bold rounded-full text-lg px-10 py-2 text-center">
                    Αποσύνδεση
                </div>
            </div>


            <div className="_w-[1300] _2xl:w-[1600px] w-full px-10 py-2 mx-auto sm:py-2 sm:px-6  lg:px-2">


                <div className="flex px-5 w-full">
                    <div className='w-full pb-3 _shadow-lg' >
                        <div className='h-full p-5 bg-white rounded-3xl -mt-0.5' >
                            <div className='flex justify-between'>

                                <div className='flex'>
                                    <RiDatabase2Line className='w-10 h-10 text-app_yellow' />
                                    <h2 className="text-3xl font-bold text-app_yellow ">Data</h2>
                                </div>

                                <div className="flex  justify-center items-center pb-1 ">

                                    <div className="pr-2 text-md font-semibold">Περίοδος: </div>
                                    <DateRangePicker
                                        className="!rounded-3xl !border-2 border-[#E0E0E0] shadow-sm "
                                        onChange={(dates)=>{
                                            //if diference is more than 6 months (183 days) show alert
                                            if(dayjs(dates[1]).diff(dayjs(dates[0]), 'days') > 183){
                                                alert('Μπορείτε να επιλέξετε μέγιστο εύρος 6 μηνών')
                                                return
                                            }


                                            onChange(dates)
                                        }}
                                        clearIcon={null}
                                        value={value}
                                        locale='el-GR'
                                        // minDetail='month'
                                        minDate={dayjs().subtract(1, 'year').toDate()}
                                        maxDate={dayjs().toDate()}
                                        //max range is 1 month
                                        maxRange={0}

                                    />
                                    {/* <div onClick={()=>{console.log(date)}}>CLICK </div> */}
                                    {/* <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="el">
                                        <DatePicker
                                            value={date}

                                            onChange={(newValue) => {
                                                setDate(newValue);
                                                
                                                settimestamps(c => getTimestampsFromDate(new Date(newValue)))

                                                // console.log(dayjs(newValue).month());
                                            }}
                                            // views={['month', 'year']}
                                            views={['month', 'year']}
                                            // openTo="year"
                                            minDate={dayjs().subtract(1, 'year')}
                                            maxDate={dayjs()}

                                        />

                                    </LocalizationProvider> */}
                                </div>
                            </div>




                            {/* <DateRangePicker 
                            onChange={onChange} 
                            value={value} 
                            locale='el-GR'
                            // minDetail='month'
                            minDate={dayjs().subtract(1, 'year').toDate()}
                            maxDate={dayjs().toDate()}

                            /> */}


                            {/* <div className='flex mt-8'>
                           <h2 className="px-5 py-1 text-xl font-bold text-white bg-gradient-to-r from-app_green to-app_blue bg-slate-300 rounded-3xl">Συνολα</h2>
                           </div>
                            <div className='flex pt-5 space-x-5'>
                                <StatBoxChart title="Πηγαδάκια" number='42' version={0}></StatBoxChart>
                                <StatBoxChart title="Μηλαδέζα" number='25' version={0}></StatBoxChart>
                                <StatBoxChart title="Βουλιαγμένη" number='5' version={0}></StatBoxChart>
                                <StatBoxChart title="Δίλοφο" number='86' version={0}></StatBoxChart>
                                <StatBoxChart title="Δικηγορικά" number='29' version={0}></StatBoxChart>

                            </div> */}
                            <div className='flex h-full pt-1 '>
                                <DataTable date={date} dates={value}></DataTable>

                            </div>



                        </div>
                    </div>






                </div>
            </div>

            <div className='h-10'></div>

            <div className="bottom-0 w-full h-5 lg:fixed bg-gradient-to-r from-app_green to-app_blue">


            </div>

            {/* logout button */}
            




        </div>
    );
}

export default Database;
